import Vue from 'vue';
import { AppScope, AppScopes } from '../constants/appScope';
import { LocaleInterface } from '../types/settingsInterface';

Vue.mixin({
  methods: {
    getScope(): AppScope | undefined {
      let scope;
      for (let i = 0; i < AppScopes.length; i++) {
        if (window.location.pathname.includes(AppScopes[i])) {
          scope = AppScopes[i];
        }
      }
      return scope;
    },
    getBrowserLanguage(): string {
      return window.navigator.languages
        ? window.navigator.languages[0]
        : window.navigator.language || (window.navigator as any).userLanguage;
    },
    getScopeLanguages(): LocaleInterface {
      const scope = this.getScope();
      if (scope && this.$store.state[scope]) {
        return this.$store.state[scope].settings.locales
          ? this.$store.state[scope].settings.locales
          : ({} as LocaleInterface);
      }
      return {} as LocaleInterface;
    },
    getDefaultLocaleByBrowser(): Object {
      let locale = this.getBrowserLanguage();
      locale = locale.replace('-', '_').toLowerCase();
      const languages = this.getScopeLanguages();
      const keys = Object.keys(languages);
      for (let language of keys) {
        if (locale.indexOf(language) !== -1) {
          return language;
        }
      }
      return 'en';
    },
    i18nTag(): string {
      const languages = this.getScopeLanguages();
      if (languages && languages[this.$i18n.locale]) {
        return languages[this.$i18n.locale].tag;
      }
      const locale = this.getDefaultLocaleByBrowser();
      return languages[locale] ? languages[locale].tag : locale;
    },
  },
});
